export default __webpack_public_path__ + "static/media/van.fa81fec9.svg";